import { Chip, styled } from '@mui/material';

export const StyledChip = styled(Chip)<{
  selected: boolean;
}>`
  min-width: 5ch;
  padding-inline: 1ch;
  gap: 4px;

  &.MuiChip-outlined {
    color: ${({ selected, theme }) => (selected ? theme.palette.text.primary : theme.palette.text.secondary)};
    border: ${({ selected, theme }) =>
      selected ? `1px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.border.main}`};
    font-weight: ${({ selected }) => (selected ? '500' : '400')};
    box-shadow: ${({ selected }) => (selected ? 'var(--shadow-small)' : 'none')};
  }

  .MuiTouchRipple-child {
    background-color: var(--mui-palette-primary-main) !important;
  }

  & > .MuiIcon-root {
    font-size: 100%;
  }
`;
